import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CheckoutStepComponent } from '../base/checkout-step.component';
import { GlobalPaymentsService } from '../../../../services/global-payments/global-payments.service';
import { first, forkJoin } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { GungModalService } from '../../../../services/gung-modal/gung-modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-global-payments-step',
  standalone: false,
  templateUrl: './global-payments-step.component.html',
  styleUrl: './global-payments-step.component.scss'
})
export class GlobalPaymentsStepComponent extends CheckoutStepComponent implements OnInit {
  protected globalPaymentsService = inject(GlobalPaymentsService);
  protected gungModalService = inject(GungModalService);
  protected translateService = inject(TranslateService);
  protected ngbModal = inject(NgbModal)

  public isVisible(): boolean {
    return false;
  }

  ngOnInit(): void {
    forkJoin({
      enable: this.globalPaymentsService.isEnabled().pipe(first()),
      use: this.globalPaymentsService.shouldUseGlobalPayment(this.checkout).pipe(first())
    }).subscribe(({ enable, use }) => {
      if (!enable || !use) {
        this.stepDone.emit(this.checkout);
        return;
      } else {
        this.gungModalService.openLoadingModal();
        this.globalPaymentsService
          .postOrderToCreateUrl(this.checkout)
          .pipe(first())
          .subscribe(response => {
            if (response?.globalPaymentsUrl) {
              window.location.href = response.globalPaymentsUrl;
            } else {
              this.gungModalService
                .openConfirmYesNoModal(
                  this.translateService.instant('ERROR'),
                  this.translateService.instant('ERROR_CREATING_PAYMENT_LINK'),
                  null,
                  'OK',
                  null
                )
                .then(res => {});
            }
            this.ngbModal.dismissAll();
          });
      }
    });
  }
}
